<template>
  <div class="analysisTwoChart">
    <div class="leftCom ashComWrap">
      <div class="comTitle">
        <h4>{{ leftTitle }}</h4>
        <el-radio-group
          v-model="hoursActive"
          size="mini"
          v-if="$route.path == '/dHWEnergy'"
          @change="hanldeClick('hoursActive', hoursActive)"
        >
          <el-radio-button v-for="v in ecList" :key="v.key" :label="v.key">{{
            v.value
          }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="comContentBox">
        <PublicEcharts
          :id="'hours'"
          :chartsData="leftCharts"
          :type="
            $route.path === '/dynamicalEnergy'
              ? 'stackedColumnBar'
              : 'lightSwitchable'
          "
        />
      </div>
    </div>
    <div class="rightCom ashComWrap">
      <div class="comTitle">
        <h4>{{ rightTitle }}</h4>
        <el-radio-group
          v-model="dateActive"
          size="mini"
          v-if="$route.path == '/dHWEnergy'"
          @change="hanldeClick('dateActive', dateActive)"
        >
          <el-radio-button v-for="v in ecList" :key="v.key" :label="v.key">{{
            v.value
          }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="comContentBox">
        <PublicEcharts
          :id="'electricity'"
          :chartsData="rightCharts"
          :type="'lightSwitchable'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
export default {
  props: ["leftCharts", "rightCharts", "leftTitle", "rightTitle"],
  components: {
    PublicEcharts,
  },
  data() {
    return {
      hoursActive: "cc",
      dateActive: "cc",
      ecList: [
        { key: "cc", value: "综合碳耗" },
        { key: "ec", value: "用电" },
        { key: "gc", value: "用气" },
        { key: "fc", value: "用水" },
      ],
    };
  },
  methods: {
    hanldeClick(type, data) {
      this.$emit("getActiveItem", { type, data });
    },
  },
};
</script>

<style lang="scss" scoped>
.analysisTwoChart {
  width: $innerWidth;
  height: 400px;
  margin: 12px auto;
  @include setFlexBetween;
  .leftCom,
  .rightCom {
    width: $halfWidth;
    height: 100%;
  }
}
</style>
